import React from 'react';
import styled from 'styled-components';
import LoadingSpinner from '@nile/components/src/Svg/AnimatedSvg/LoadingSpinner.svg';
import LoadingSuccess from '@nile/components/src/Svg/AnimatedSvg/LoadingSuccess.svg';
import LoadingError from '@nile/components/src/Svg/AnimatedSvg/LoadingError.svg';

const LoaderWrapper = styled.div`
  svg {
    height: 16px;
    width: 16px;
  }
`;

function ApiProgressLoader(props) {
  const { isLoading, isSuccess, isError } = props;
  const getSpinnerState = () => {
    if (isLoading) {
      return <LoadingSpinner />;
    }
    if (isSuccess) {
      return <LoadingSuccess />;
    }
    if (!isSuccess) {
      return <LoadingError />;
    }
    return '';
  };
  return (
    <LoaderWrapper className="api-loader flex jctr">
      {getSpinnerState()}
    </LoaderWrapper>
  );
}

export default ApiProgressLoader;
